export default __webpack_public_path__ + "static/media/q13.39009503.png";